import React from "react"
import { Link } from "../../common/components/link";
import { links } from "../../routes";
import { InterventiTable } from "./InterventiTable";
import { RouteComponentProps } from "react-router-dom";
import { Loading } from "../../common/components/loading";
import { CustomerData } from "../../customers/components/CustomerData";
import InterventiStore from "../interventiStore";

interface Props extends RouteComponentProps<{ idCliente: string }> {
}

export default (props: Props) => {

    const { match: { params: { idCliente: idClienteStr } } } = props;
    const idCliente = parseInt(idClienteStr);
    const interventi = InterventiStore.useForCliente(idCliente);
    if (!interventi)
        return <Loading />
    return <div className="card">
        <div className="card-header d-flex bg-theme align-items-center" >
            <h3 className="text-white flex-fill">Interventi <CustomerData id={idCliente} template={x => `${x.cognomeProprietario} ${x.nomeProprietario}`} /></h3>
            <Link to={links.interventoNew({ idCliente })} className="btn btn-outline-secondary"><i className="fas fa-plus" /> Aggiungi</Link>
        </div>
        <div className="card-body">
            <InterventiTable
                interventi={interventi}
            />
        </div>
    </div>

};